import { Chip } from '@mui/material';

import type { LicenceState } from '../api/shared';
import { useT } from '../i18n/LanguageContext';

const COLOURS: Record<LicenceState, 'success' | 'error' | 'warning' | 'info'> = {
  ACTIVE: 'success',
  SUSPENDED: 'error',
  AWAITING_PAYMENT: 'warning',
  EXPIRED: 'warning',
  NOT_YET_VALID: 'info',
};

export const LicenceStateChip = ({ state }: { state: LicenceState }) => {
  const t = useT();

  return (
    <Chip
      size="small"
      variant="outlined"
      color={COLOURS[state]}
      label={t(`licenceState.${state}` as const)}
    />
  );
};
